import { gql, useLazyQuery } from '@provision/graphql-client';
import { useCallback } from 'react';

const GET_PRESIGNED_DELETE_URL_QUERY = gql`
  query GetPlatformUserAvatarDeleteUrl($fileKey: String!) {
    getPreSignedDeleteUrl(params: { fileKey: $fileKey }) {
      url
    }
  }
`;

interface GetPreSignedDeleteUrlResult {
  getPreSignedDeleteUrl: {
    url: string;
  };
}

export function useDeletePlatformUserAvatar() {
  const [getPreSignedDeleteUrl] = useLazyQuery<GetPreSignedDeleteUrlResult>(
    GET_PRESIGNED_DELETE_URL_QUERY,
    { fetchPolicy: 'no-cache', context: { ttl: 0 } },
  );

  const deleteAvatar = useCallback(
    async (storageKey: string | undefined) => {
      if (!storageKey) {
        return;
      }

      const { data } = await getPreSignedDeleteUrl({ variables: { fileKey: storageKey } });
      const url = data?.getPreSignedDeleteUrl?.url;
      if (!url) {
        console.error('Failed to get presigned delete URL for platform-user avatar');
        return;
      }

      const response = await fetch(url, { method: 'DELETE' });
      if (!response.ok) {
        console.error(`Platform-user avatar delete failed: ${response.statusText}`);
      }
    },
    [getPreSignedDeleteUrl],
  );

  return { deleteAvatar };
}
